import * as React from "react";
import AdminApprovalWorkView from "./components/AdminApprovalWork";

export default function AdminWorkApprovalViewPage() {
    return (
    <>
      <AdminApprovalWorkView />
    </>
  );
}